import { Trans, useTranslation } from 'react-i18next';

import type { AssetFamily } from '~/modules/artist-roster/types';

import { ContributorLinks } from './ContributorLinks';

interface TrackTableParticipantsCellProps {
  asset: AssetFamily;
}

export function TrackTableParticipantsCell({
  asset: { contributors },
}: TrackTableParticipantsCellProps) {
  const { t } = useTranslation('roster');

  return (
    <div className="flex flex-col px-sm">
      <div aria-label={t('trackList.contributors.mainArtistsLabel')}>
        <Trans
          t={t}
          i18nKey="trackList.contributors.mainArtists"
          components={{
            strong: <span className="font-semibold" />,
            Artists: (
              <ContributorLinks
                type="PRIMARY_ARTIST"
                contributors={contributors}
              />
            ),
          }}
        />
      </div>
      <div aria-label={t('trackList.contributors.featuredArtistsLabel')}>
        <Trans
          t={t}
          i18nKey="trackList.contributors.featuredArtists"
          components={{
            strong: <span className="font-semibold" />,
            Artists: (
              <ContributorLinks
                type="FEATURED_ARTIST"
                contributors={contributors}
              />
            ),
          }}
        />
      </div>
    </div>
  );
}

TrackTableParticipantsCell.displayName = 'TrackTableParticipantsCell';
